import { CartItemTypeEnum } from '../cart/cart-item';
import { CartItemSponsorshipSelected } from '../cart/sponsorship';
import {
  ChildBase,
  ChildBirthday,
  ChildGender,
  ChildIcp,
  ChildImageUrl,
  ChildName,
} from '../children/childUtilityInterfaces';

export enum UpsellItemTypeEnum {
  // Fund = 'Fund',
  Sponsorship = 'Sponsorship',
}

export type UpsellSponsorshipItem = {
  itemType: CartItemTypeEnum.Sponsorship;
  child: ChildBase &
    ChildBirthday &
    ChildGender &
    ChildImageUrl &
    ChildIcp &
    ChildName;
  sponsorship: CartItemSponsorshipSelected;
};

// export type UpsellFundItem = CartItemFund
//     & Pick<CartItemBase, 'id' | 'added' | 'amount'>;

export type UpsellItem = UpsellSponsorshipItem; // | UpsellFundItem;
